var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "customer-panel"
  }, [_c('div', {
    staticClass: "calc-cost-table-wrapper"
  }, [_c('CalcCostTable', {
    attrs: {
      "hideColumn": ['客户', '材料', '配方', '金蝶云'],
      "tableLoading": _vm.calcCostTableLoading
    }
  })], 1), _c('Divider', {
    attrs: {
      "orientation": "left"
    }
  }, [_vm._v("销量分析")]), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticStyle: {
      "width": "500px",
      "height": "250px"
    },
    attrs: {
      "id": "monthlyVolStatChart"
    }
  }), _c('div', [_c('h2', [_vm._v("最近60天订单")]), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.recentVolCol,
      "data": _vm.sixtyDayOrders,
      "height": "250",
      "width": "500"
    }
  })], 1)]), _c('Divider', {
    attrs: {
      "orientation": "left"
    }
  }, [_vm._v("回款分析")]), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticStyle: {
      "width": "500px",
      "height": "250px"
    },
    attrs: {
      "id": "monthlyReceiveStatChart"
    }
  }), _c('div', [_c('h2', [_vm._v("最近1年收款记录")]), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.receiveCol,
      "data": _vm.receiveList,
      "height": "250",
      "width": "600"
    }
  })], 1)]), _c('div', {
    staticClass: "flex"
  }, _vm._l(_vm.salesStat, function (ss) {
    var _ss$company, _ss$arTable;
    return _c('div', [_c('h2', [_vm._v(_vm._s((_ss$company = ss.company) === null || _ss$company === void 0 ? void 0 : _ss$company.abbr) + "账龄（截止" + _vm._s(_vm.artableDate.year) + "/" + _vm._s(_vm.artableDate.month) + "末）")]), _c('Table', {
      attrs: {
        "columns": _vm.arTableCol,
        "data": (_ss$arTable = ss.arTable) !== null && _ss$arTable !== void 0 ? _ss$arTable : [],
        "border": ""
      }
    })], 1);
  }), 0)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }